<template>
  <div class="title-line-base"><h5 class="title-line">Focus on</h5></div>
  <div class="wrapper">
    <div class="block-left">
      <div class="block-image">
        <img
          alt="submenu image"
          :src="require(`@/assets/home/pohutukawa-home.jpg`)"
          :style="{
            objectFit: 'cover',
          }"
        />
        <router-link
          v-if="this.pohutukawa"
          :to="{ path: `/plants/${this.pohutukawa.id}` }"
        >
          <div class="overlay">
            <div class="title">The iconic New Zealand's Christmas tree</div>
            <router-link
              v-if="this.pohutukawa"
              class="link"
              :to="{ path: `/plants/${this.pohutukawa.id}` }"
            >
              See more details
            </router-link>
          </div>
        </router-link>
      </div>
    </div>
    <div class="block-right">
      <div class="block-right-top">
        <div class="block-image">
          <img
            alt="submenu image"
            :src="require(`@/assets/home/crown-fern.jpg`)"
            :style="{
              objectFit: 'cover',
            }"
          />
          <div class="overlay">
            <div class="title">History of Ferns</div>
            <div class="link">
              <span class="label">Coming soon</span>
            </div>
          </div>
        </div>
      </div>
      <div class="block-right-bottom block-right-bottom-1">
        <div class="block-image">
          <img
            alt="submenu image"
            :src="require(`@/assets/home/kauri.jpg`)"
            :style="{
              objectFit: 'cover',
            }"
          />
          <router-link
            v-if="this.kauri"
            :to="{ path: `/plants/${this.kauri.id}` }"
          >
            <div class="overlay">
              <div class="title">Kauri</div>
              <router-link
                v-if="this.kauri"
                class="link"
                :to="{ path: `/plants/${this.kauri.id}` }"
              >
                See more details
              </router-link>
            </div></router-link
          >
        </div>
      </div>
      <div class="block-right-bottom block-right-bottom-2">
        <div class="block-image">
          <img
            alt="submenu image"
            :src="require(`@/assets/home/cabbage-tree.jpg`)"
            :style="{
              objectFit: 'cover',
            }"
          />
        </div>
      </div>
      <div class="block-right-bottom block-right-bottom-3">
        <div class="block-image">
          <img
            alt="submenu image"
            :src="require(`@/assets/home/cabbage-tree.jpg`)"
            :style="{
              objectFit: 'cover',
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlocksHome",
  props: {
    pohutukawa: undefined,
    kauri: undefined,
  },
};
</script>
<style lang="scss" scoped>
.title-line-base {
  text-align: center;
  position: relative;
}
.title-line-base::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 50%;
  width: 100%;
  border-top: 4px solid $color-primary;
  margin-top: -2px;
}
.title-line {
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 0px;
  margin-top: 0px;
  position: relative;
  background: rgb(255, 255, 255) none repeat scroll 0% 0%;
}

.wrapper {
  grid-gap: 10px;
  color: #444;
  display: flex;
  flex-direction: column;
  @media (min-width: $breakpoint-small) {
    display: grid;
    grid-template-columns: repeat(2, [col] auto);
  }
}

.block-left {
  position: relative;
  .img {
    height: 300px;
  }
  @media (min-width: $breakpoint-small) {
    grid-column: col / span 1;
    grid-row: row 2;

    height: 300px;
    @media (min-width: $breakpoint-large) {
      height: 300px;
    }
    @media (min-width: $breakpoint-x-large) {
      height: 470px;
    }
  }
}
.overlay {
  position: absolute;
  bottom: 0px;
  color: rgb(255, 255, 255);
  text-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px;
  left: 0px;
  right: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: rgba($color-primary, 0.5);
  transition: all 0.3s;

  &:hover {
    background-color: rgba($color-primary, 0.9);
    transform: scale(1.05);
  }

  @media (min-width: $breakpoint-large) {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  .title,
  .link {
    color: rgb(255, 255, 255);
    margin: 0;
  }

  .title {
    font-weight: 600;
    @media (min-width: $breakpoint-large) {
      font-size: 1.2rem;
      line-height: 2rem;
    }
    @media (min-width: $breakpoint-x-large) {
      font-size: 1.5rem;
      line-height: 2.5rem;
    }
  }
  .link {
    font-size: 0.8rem;
    @media (min-width: $breakpoint-large) {
      font-size: 1rem;
    }
    @media (min-width: $breakpoint-x-large) {
      font-size: 1rem;
    }
  }
}
.block-right {
  display: grid;
  grid-gap: 10px;
  @media (min-width: $breakpoint-small) {
    grid-row: row 2;
    display: grid;
    grid-gap: 20px;
  }
}

.block-image {
  @media (min-width: $breakpoint-small) {
    position: absolute;
    inset: 0px;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 230px;

    @media (min-width: $breakpoint-small) {
      height: 100%;
      position: absolute;
    }
  }
}
.block-right-top {
  position: relative;
  @media (min-width: $breakpoint-small) {
    grid-column: 1;
    grid-row: 1;
    position: relative;
    @media (min-width: $breakpoint-large) {
      grid-column: 1 / 4;
      grid-row: 1;
    }
    height: 140px;
    @media (min-width: $breakpoint-large) {
      height: 140px;
    }
    @media (min-width: $breakpoint-x-large) {
      height: 230px;
    }
  }
}
.block-right-bottom {
  position: relative;

  @media (min-width: $breakpoint-small) {
    height: 140px;
    @media (min-width: $breakpoint-large) {
      height: 140px;
    }
    @media (min-width: $breakpoint-x-large) {
      height: 220px;
    }
  }
}
.block-right-bottom-1 {
  grid-column: 2;
  grid-row: 1;
  @media (min-width: $breakpoint-large) {
    grid-column: 1;
    grid-row: 2;
  }
}
.block-right-bottom-2 {
  grid-column: 1;
  grid-row: 2;
  @media (min-width: $breakpoint-large) {
    grid-column: 2;
    grid-row: 2;
  }
}
.block-right-bottom-3 {
  grid-column: 2;
  grid-row: 2;
  @media (min-width: $breakpoint-large) {
    grid-column: 3;
    grid-row: 2;
  }
}
</style>
